import React, { useState } from "react";
import { changePassword } from "../../services/userService";
import { toast } from "react-toastify";
import { FiEye, FiEyeOff } from "react-icons/fi";

const ChangePasswordModal = ({ open, onClose, user }) => {

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const [error, setError] = useState("");

    if (!open) return null;

    const handleChange = async () => {

        setError("");

        if (!password) {
            setError("Password is required");
            return;
        }

        if (password.length < 6) {
            setError("Password must be at least 6 characters");
            return;
        }

        if (password !== confirmPassword) {
            setError("Passwords do not match");
            return;
        }

        const toastId = toast.loading("Updating password...");

        try {

            const response = await changePassword(user.id, password);

            toast.update(toastId, {
                render:
                    response?.message || "Password updated successfully",
                type: "success",
                isLoading: false,
                autoClose: 3000,
            });

            onClose();

        } catch (error) {

            console.error(error);

            const errorMessage =
                error?.response?.data?.detail ||
                error?.response?.data?.message ||
                "Failed to change password";

            setError(errorMessage);

            toast.update(toastId, {
                render: errorMessage,
                type: "error",
                isLoading: false,
                autoClose: 4000,
            });
        }
    };

    return (
        <div className="fixed inset-0 bg-black/40 flex justify-center items-center z-50">

            <div className="bg-white p-8 rounded-2xl w-full max-w-md">

                <h2 className="text-2xl font-bold mb-5">
                    Change Password
                </h2>

                {/* Password */}
                <div className="relative mb-4">

                    <input
                        type={showPassword ? "text" : "password"}
                        className="w-full border rounded-xl p-3 pr-12"
                        placeholder="New Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    />

                    <button
                        type="button"
                        onClick={() =>
                            setShowPassword(!showPassword)
                        }
                        className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500"
                    >
                        {showPassword ? (
                            <FiEyeOff size={20} />
                        ) : (
                            <FiEye size={20} />
                        )}
                    </button>

                </div>

                {/* Confirm Password */}
                <div className="relative">

                    <input
                        type={showConfirmPassword ? "text" : "password"}
                        className="w-full border rounded-xl p-3 pr-12"
                        placeholder="Confirm Password"
                        value={confirmPassword}
                        onChange={(e) =>
                            setConfirmPassword(e.target.value)
                        }
                    />

                    <button
                        type="button"
                        onClick={() =>
                            setShowConfirmPassword(!showConfirmPassword)
                        }
                        className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500"
                    >
                        {showConfirmPassword ? (
                            <FiEyeOff size={20} />
                        ) : (
                            <FiEye size={20} />
                        )}
                    </button>

                </div>

                {/* Error Message */}
                {error && (
                    <p className="text-red-500 text-sm mt-2">
                        {error}
                    </p>
                )}

                <div className="flex justify-end gap-3 mt-6">

                    <button
                        onClick={onClose}
                        className="border px-5 py-2 rounded-xl"
                    >
                        Cancel
                    </button>

                    <button
                        onClick={handleChange}
                        className="bg-orange-500 hover:bg-orange-600 text-white px-5 py-2 rounded-xl"
                    >
                        Update Password
                    </button>

                </div>

            </div>

        </div>
    );
};

export default ChangePasswordModal;